module.exports = __webpack_public_path__ + "media/images/pic/anime/airplane-679978269c89ff08a6c7f4f167efa889.svg";